module.exports = __webpack_public_path__ + "img/wario-min.bc0318a4.png";